import { atom } from "jotai";
export var expandPathAtom = atom([]);